import BrandingColors from '../styles/color';

export const appBarContentStyle = {
    backgroundColor: BrandingColors.white,
    borderBottom: `2px solid ${BrandingColors.yellowOrange}`,
    boxShadow: 'none',
    color: BrandingColors.darkBlack
};

export const headerIconButtonStyle = {
    '&.Mui-focusVisible': {
        boxShadow: `inset 0 0 0 2px ${BrandingColors.brightTealDark}`
    }
};
